export default function PageHeader({ eyebrow, title, description, testId }) {
  return (
    <header
      data-testid={testId || "page-header"}
      className="pt-32 md:pt-40 pb-16 md:pb-24 border-b border-[#e5e7eb]"
    >
      <div className="container-page">
        {eyebrow && <p className="eyebrow mb-6">{eyebrow}</p>}
        <h1 className="font-display font-extrabold text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tighter max-w-5xl">
          {title}
        </h1>
        {description && (
          <p className="mt-8 max-w-2xl text-lg text-[#4B5563] leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </header>
  );
}
